import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import useElement from "backend/hooks/elements/useElement";
import useFlatHierarchy from "backend/hooks/elements/useFlatHierarchy";
import ToolbarWithHeading from "components/toolbars/ToolbarWithHeading";
import { KpisHeader, MeasurementHeader } from "design/components/texts/Headers";
import { KPICard } from "design/components/cards/KPICard";
import MeasureGridArea from "design/components/grids/MeasureGridArea";
import SplitView from "design/layouts/SplitView";
import Page from "design/pages/Page";
import React from "react";
import PageContainer from "design/layouts/PageContainer";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import Center from "design/layouts/Center";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import { t } from "i18next";

const KPIs = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data: root } = useScorecardTopElement("L0");

  const { data, isLoading, isPreviousData, isRefetching } = useFlatHierarchy(
    ctx.elementId || root?.id
  );
  const { data: element, isLoading: isElementLoading } = useElement(
    ctx.elementId || root?.id
  );

  return (
    <Page
      isLoading={
        isLoading || isPreviousData || isRefetching || isElementLoading
      }
      Toolbar={StrategyToolbar}
    >
      <PageContainer width="1350px">
        <MeasureGridArea>
          <KpisHeader header={t("kpis.KPIs")} />
          {data
            ? data
                .filter((el) => el.typename === "KPI")
                .map((el) => (
                  <KPICard
                    valueKey="PERF_YTD"
                    prettyKey="PERF_YTD_prettyvalue"
                    colorKey="rangecolor_PERF_YTD_OPEN"
                    series={[
                      {
                        title: t("kpis.Actual (YTD)"),
                        series: "ACT_YTD_prettyvalue",
                      },
                      {
                        title: t("kpis.Target (YTD)"),
                        series: "TAR_YTD_prettyvalue",
                      },
                    ]}
                    period={ctx.period || ""}
                    key={`${el.id}-${ctx.period}`}
                    element={el}
                    onSelect={() => {
                      link({ page: "kpidetails", meaId: el.id });
                    }}
                  />
                ))
            : null}
        </MeasureGridArea>
      </PageContainer>
    </Page>
  );
};

export default KPIs;
